import { version } from '../../version.json';
import defaultConfig from '../../global-variables';

/**
 * Strips environment prefix from version string
 * e.g., "development-1.1.346" -> "1.1.346"
 * e.g., "production-2.0.1" -> "2.0.1"
 */
function stripEnvironmentPrefix(versionString: string): string {
  if (!versionString) return '';
  
  // Remove environment prefixes like "development-", "production-", "staging-", "testing-", "local-"
  const prefixes = ['development-', 'production-', 'staging-', 'testing-', 'local-'];
  
  for (const prefix of prefixes) {
    if (versionString.startsWith(prefix)) {
      return versionString.substring(prefix.length);
    }
  }
  
  return versionString;
}

/**
 * Formats a version string by stripping environment prefix
 * e.g., "development-1.1.346" -> "1.1.346"
 */
export function formatVersion(versionString: string): string {
  return stripEnvironmentPrefix(versionString);
}

/**
 * Gets the UI version
 */
export function getVersion() {
  return formatVersion(version || '');
}

/**
 * Fetches the REST API version from the backend
 */
export async function getRestApiVersion(): Promise<string> {
  try {
    const url = `${defaultConfig.externalAPIUrl}/cp-be`;
    const response = await fetch(url);
    
    if (!response.ok) {
      console.error('Failed to fetch REST API version:', response.statusText);
      return '...';
    }
    
    const data = await response.json();
    return formatVersion(data.version || '');
  } catch (error) {
    console.error('Error fetching REST API version:', error);
    return '...';
  }
}
